// client/src/utils/passwordPolicy.js
// Single source of truth for the password policy. Used by the signup flow
// (SignupStepOne) and the change-password modal (ProfilePage) so both
// enforce the same (stricter) rules.
//
// Returns an array of human-readable requirements the password fails;
// an empty array means the password is valid.
export const validatePassword = (password) => {
  const pwd = password || '';
  const errors = [];
  if (pwd.length < 8) errors.push('At least 8 characters');
  if (!/[A-Z]/.test(pwd)) errors.push('At least one uppercase letter');
  if (!/[a-z]/.test(pwd)) errors.push('At least one lowercase letter');
  if (!/[0-9]/.test(pwd)) errors.push('At least one number');
  if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(pwd)) errors.push('At least one special character');
  return errors;
};
